<section>
  <h1 class="typewriter">404 NOT FOUND</h1>
  <p>Il semble que vous vous soyez malencontreusement égaré.</p>
  <p><a [routerLink]="['/']">Retour à l'accueil</a></p>
</section>
